/* eslint-disable*/
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import ReactHighChart from 'react-highcharts';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Tooltip } from 'react-tippy';
import Scrollbar from 'smooth-scrollbar-react';
import { CHART_TYPES } from '../../constants';

import lineChart from '../../assets/images/line_chart.svg';
import barChart from '../../assets/images/bar_chart.svg';
import lineChartSelected from '../../assets/images/line_chart_selected.svg';
import barChartSelected from '../../assets/images/bar_chart_selected.svg';

const RatesTab = ({
  parseFloatKeep,
  unit,
  showLastYearTaxes,
  showNotPublishedForZeroTaxRate,
  taxingUnitChartType,
  isUseTaxElectionRate,
  isWaterRate,
  openWorksheetPDF,
  buildLineChartConfig
}) => {
  const [ chartType, setChartType ] = useState();

  useState(() => {
    setChartType(CHART_TYPES.COLUMN);
  }, []);

  console.log(unit);

  return (
    <div>
      <div className='main-rate-container'>
        <div style={{ position: 'relative' }}>
          <span className='sub-title'>
            Taxable Value: {' '}
          </span>
          <span>
            $
            <NumberFormat
              displayType={'text'}
              thousandSeparator
              value={parseFloatKeep(unit.taxableValue)}
            />
          </span>
        </div>
        {Boolean(showLastYearTaxes) && (
          <div>
            <span className='sub-title'>
              Last Year's Taxes: {' '}
            </span>
            <span>
              $
              <NumberFormat
                displayType={'text'}
                thousandSeparator
                value={parseFloatKeep(unit.lastYearTaxes)}
              />
            </span>
          </div>
        )}
      </div>
      <div className='row chart-container'>
        <div className='col-12 col-sm-12 col-md-4 order-1 order-sm-1 order-md-last chart-wrapper'>
          <div
            className='row'
            style={{ justifyContent: 'flex-end', paddingRight: 15 }}
          >
            <img
              alt='bar chart'
              src={chartType === CHART_TYPES.COLUMN ? barChartSelected : barChart}
              style={{ cursor: 'pointer', marginRight: '10px' }}
              onClick={() => setChartType(CHART_TYPES.COLUMN)}
            />
            <img
              alt='line chart'
              src={chartType === CHART_TYPES.LINE ? lineChartSelected : lineChart}
              style={{ cursor: 'pointer' }}
              onClick={() => setChartType(CHART_TYPES.LINE)}
            />
          </div>
          {(chartType !== CHART_TYPES.COLUMN || taxingUnitChartType !== 'Hybrid') ?
            <ReactHighChart config={buildLineChartConfig(unit, chartType)} /> :
            <HighchartsReact
              highcharts={Highcharts}
              options={{ ...buildLineChartConfig(unit, chartType),
                credits: {
                  enabled: false,
                },
                lang: {
                  thousandsSep: ','
                }
              }}
            />
          }

          {parseInt(unit.freezeYr, 10) > 0 && (
            <Tooltip
              html={
                <div>
                  Your current taxes for this taxing unit are limited
                  by an exemption you qualified in
                  <span style={{ color: '#b7cd2a' }}> {unit.freezeYr} </span>
                  for property owners that are disabled or 65 years of
                  age or older. Your taxes are limited to not increase
                  above
                  <span style={{ color: '#b7cd2a' }}>
                    {' '}$
                    <NumberFormat
                      displayType={'text'}
                      thousandSeparator
                      value={parseFloatKeep(unit.freezeCeiling)}
                    />{' '}
                  </span>
                  unless certain new improvements are made to your
                  residence that are excluded from this limitation.
                </div>
              }
              position='bottom'
              trigger='mouseenter'
            >
              <div className='tag-container'>
                <span>Tax Limitation</span>
              </div>
            </Tooltip>
          )}
        </div>
        <div className='col-12 col-sm-12 col-md-8 order-2 order-sm-2 order-md-first rate-container'>
          <Scrollbar alwaysShowTracks className='custom-scroll-wrapper'>
            <div className='sub-rate-value-container'>
              <div className='row sub-rate-container'>
                {
                  Boolean(showLastYearTaxes) &&
                  <div className='col-2'>
                    <span className='label'>
                      <span>{Number(unit.taxingUnitYr) - 1} Tax Rate</span>
                    </span>
                  </div>
                }

                <div className='col-2'>
                  <span className='label'>
                    <span>{unit.taxingUnitYr} {
                      (isWaterRate(unit) && isUseTaxElectionRate(unit)) ?
                        'Tax Election' :
                        `${unit.taxingUnitType === 'School' || unit.taxingUnitType === 'School - Chapter 313' ? 'Rate to Maintain' : 'No New Revenue'}`
                    }</span>
                  </span>
                </div>
                <div className='col-2'>
                  <span className='label'>
                    <span>{unit.taxingUnitYr} Proposed</span>
                  </span>
                </div>
                <div className='col-2'>
                  <span className='label'>Difference</span>
                </div>
                <div className='col-2'>
                  <span className='label'>
                    <span>{unit.taxingUnitYr} Voter Approval</span>
                  </span>
                </div>
                <div className='col-2'>
                  <span className='label'>
                    <span>{unit.taxingUnitYr} Adopted</span>
                  </span>
                </div>
              </div>
              <div className='row sub-rate-container'>
                <div className='sub-rate-label-container'>
                  <span className='label'>Rate</span>
                  <span className='label'>Amount</span>
                  <span className='label'>Worksheet</span>
                </div>
                {
                  Boolean(showLastYearTaxes) &&
                  <div className='col-2'>
                    {
                      (showNotPublishedForZeroTaxRate && (!unit.prior_adoptedRate || isNaN(unit.prior_adoptedRate) || Number(unit.prior_adoptedRate) === 0)) ?
                        <>
                          <div className='value not-published'>Not Published</div>
                          <div className='value not-published'>Not Published</div>
                        </>
                        :
                        <>
                          <div className='value'>
                            {unit.prior_adoptedRate}
                          </div>
                          <div className='value'>
                            <>
                              $
                              <NumberFormat
                                displayType={'text'}
                                thousandSeparator
                                value={parseFloatKeep(unit.lastYearTaxes)}
                              />
                            </>
                          </div>
                        </>

                    }
                    <div className='value' />
                  </div>
                }

                <div className='col-2'>
                  {
                    (isWaterRate(unit) && isUseTaxElectionRate(unit)) ?
                      <>
                        {
                          (showNotPublishedForZeroTaxRate && (!unit.mandatoryTaxElectionRate || isNaN(unit.mandatoryTaxElectionRate) || Number(unit.mandatoryTaxElectionRate) === 0)) ?
                            <>
                              <div className='value not-published'>Not Published</div>
                              <div className='value not-published'>Not Published</div>
                            </>
                            :
                            <>
                              <div className='value'>
                                {unit.mandatoryTaxElectionRate}
                              </div>
                              <div className='value'>
                                $
                                <NumberFormat
                                  displayType={'text'}
                                  thousandSeparator
                                  value={parseFloatKeep(unit.tax_mandatoryTaxElectionRate)}
                                />
                              </div>
                            </>

                        }
                        <div className='value'>
                          {unit.mandatoryTaxElectionRateS3ID && (
                            <a
                              className='doc-link'
                              onClick={() =>
                                openWorksheetPDF(
                                  'mandatoryTaxElectionRate',
                                  unit.taxingUnitID
                                )
                              }
                            >
                              {unit.taxingUnitYr} Tax Election Worksheet
                            </a>
                          )
                          }
                        </div>

                      </> :
                      <>
                        {
                          (showNotPublishedForZeroTaxRate && (!unit.effTaxRate || isNaN(unit.effTaxRate) || Number(unit.effTaxRate) === 0)) ?
                            <>
                              <div className='value not-published'>Not Published</div><div className='value not-published'>Not Published</div>
                            </> :
                            <>
                              <div className='value'>
                                {unit.effTaxRate}
                              </div>
                              <div className='value'>
                                $
                                <NumberFormat
                                  displayType={'text'}
                                  thousandSeparator
                                  value={parseFloatKeep(unit.tax_effTaxRate)}
                                />
                              </div>
                            </>

                        }
                        <div className='value'>

                          {unit.etrWorksheetS3ID && (
                            <a
                              className='doc-link'
                              onClick={() =>
                                openWorksheetPDF(
                                  'effectiveRate',
                                  unit.taxingUnitID
                                )
                              }
                            >
                              {unit.taxingUnitYr} No New Revenue Worksheet
                            </a>
                          )
                          }
                        </div>

                      </>
                  }
                </div>
                <div className='col-2'>
                  {
                    (showNotPublishedForZeroTaxRate && (!unit.proposedRate || isNaN(unit.proposedRate) || Number(unit.proposedRate) === 0)) ?
                      <>
                        <div className='value not-published'>Not Published</div>
                        <div className='value not-published'>Not Published</div>
                      </> :
                      <>
                        <div className='value'>
                          {unit.proposedRate}
                        </div>
                        <div className='value'>
                          $
                          <NumberFormat
                            displayType={'text'}
                            thousandSeparator
                            value={parseFloatKeep(unit.tax_proposedTaxRate)}
                          />
                        </div>
                      </>

                  }
                  <div className='value'>

                    {unit.taxRateProposedS3ID &&
                      <a
                        className='doc-link'
                        onClick={() =>
                          openWorksheetPDF(
                            'proposedRate',
                            unit.taxingUnitID
                          )
                        }
                      >
                        Worksheet
                      </a>
                    }
                  </div>

                </div>
                <div className='col-2'>
                  <div className='value' />
                  {Boolean(unit.effTaxRate && Number(unit.effTaxRate) && unit.proposedRate && Number(unit.proposedRate) && unit.difference) && (
                    <>
                      {
                        Number(unit.difference) >= 0 ?
                          <div className='value'>
                            $
                            <NumberFormat
                              displayType={'text'}
                              thousandSeparator
                              value={parseFloatKeep(unit.difference)}
                            />
                          </div> :
                          <div className='value' style={{ color: 'red' }}>
                            ($
                            <NumberFormat
                              displayType={'text'}
                              thousandSeparator
                              value={parseFloatKeep(unit.difference, true)}
                            />
                            )
                          </div>
                      }
                    </>
                  )}
                  <div className='value' />
                </div>
                <div className='col-2'>
                  {
                    (showNotPublishedForZeroTaxRate && (!unit.rollbackRate || isNaN(unit.rollbackRate) || Number(unit.rollbackRate) === 0)) ?
                      <>
                        <div className='value not-published'>Not Published</div>
                        <div className='value not-published'>Not Published</div>
                      </>
                      :
                      <>
                        <div className='value'>
                          {unit.rollbackRate}
                        </div>
                        <div className='value'>
                          $
                          <NumberFormat
                            displayType={'text'}
                            thousandSeparator
                            value={parseFloatKeep(unit.tax_rollbackRate)}
                          />
                        </div>
                      </>
                  }
                  <div className='value'>

                    {unit.taxRateVoterApprovalS3ID &&
                      <a
                        className='doc-link'
                        onClick={() =>
                          openWorksheetPDF(
                            'rollbackRate',
                            unit.taxingUnitID
                          )
                        }
                      >
                        Worksheet
                      </a>
                    }
                  </div>

                </div>
                <div className='col-2'>
                  {
                    (showNotPublishedForZeroTaxRate && (!unit.adoptedRate || isNaN(unit.adoptedRate) || Number(unit.adoptedRate) === 0)) ?
                      <>
                        <div className='value not-published'>Not Published</div>
                        <div className='value not-published'>Not Published</div>
                      </>
                      :
                      <>
                        <div className='value'>
                          {unit.adoptedRate && (
                            <span>{unit.adoptedRate}</span>
                          )}
                        </div>
                        <div className='value'>
                          {unit.tax_adoptedRate && (
                            <span>
                              $
                              <NumberFormat
                                displayType={'text'}
                                thousandSeparator
                                value={parseFloatKeep(unit.tax_adoptedRate)}
                              />
                            </span>
                          )}

                        </div>
                      </>

                  }
                  <div className='value'>

                    {unit.taxRateAdoptionS3ID &&
                      <a
                        className='doc-link'
                        onClick={() =>
                          openWorksheetPDF(
                            'adoptedRate',
                            unit.taxingUnitID
                          )
                        }
                      >
                        Adopted Tax Rate Statement
                      </a>
                    }
                  </div>

                </div>
              </div>
            </div>
          </Scrollbar>
        </div>
      </div>
    </div>
  );
};

RatesTab.propTypes = {
  buildLineChartConfig: PropTypes.func.isRequired,
  isUseTaxElectionRate: PropTypes.func.isRequired,
  isWaterRate: PropTypes.func.isRequired,
  openWorksheetPDF: PropTypes.func.isRequired,
  parseFloatKeep: PropTypes.func.isRequired,
  showLastYearTaxes: PropTypes.any,
  showNotPublishedForZeroTaxRate: PropTypes.any,
  taxingUnitChartType: PropTypes.any,
  unit: PropTypes.any
};

export default RatesTab;
